import Link from 'next/link'
import {cn} from '../../../lib/utils'

type PublicEventDetailsLinkProps = {
    ariaLabel: string
    className?: string
    href: string | null
}

export function PublicEventDetailsLink({ariaLabel, className, href}: PublicEventDetailsLinkProps) {
    if (!href) return null
    return (
        <Link
            href={href}
            aria-label={ariaLabel}
            data-public-details-navigation="page"
            className={cn(className)}
        />
    )
}
